module.exports = __webpack_public_path__ + "static/media/sub-card-label-3-over.68674ad6.svg";